'use client';

import React, { useState, ChangeEvent, useEffect } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from 'app/components/ui/dialog';
import { Input } from 'app/components/ui/input';
import { Button } from 'app/components/ui/button';
import { Label } from 'app/components/ui/label';
import { useBlogsSlice } from '../../slice';
import { useToast } from 'app/components/ui/use-toast';

interface DialogaddTagProps {
  isOpen: boolean;
  onClose: () => void;
}

const DialogaddTag: React.FC<DialogaddTagProps> = ({ isOpen, onClose }) => {
  const [tagName, setTagName] = useState<string>('');
  const { useAddTagsMutation } = useBlogsSlice();
  const { toast } = useToast();

  const [addTag, { data, error, isLoading }] = useAddTagsMutation();

  const handleSave = () => {
    addTag({ name: tagName });
  };

  useEffect(() => {
    if (error) {
      console.log(error);
      toast({
        title: 'Error',
        description: error?.data?.message,
        variant: 'destructive',
      });
    }
  }, [error]);

  useEffect(() => {
    if (data) {
      console.log(data);
      toast({
        title: 'Success',
        description: data?.message,
      });
      onClose();
      setTagName('');
    }
  }, [data]);

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Add New Tag</DialogTitle>
        </DialogHeader>
        <div className="space-y-6 px-4">
          <div className="space-y-2">
            <Label htmlFor="tagName" className="text-sm font-medium">
              Tag Name
            </Label>
            <Input
              id="tagName"
              type="text"
              placeholder="Enter tag name"
              value={tagName}
              onChange={e => setTagName(e.target.value)}
              disabled={isLoading}
            />
          </div>
        </div>
        <DialogFooter className="mt-6 px-4 space-x-2 pb-[10px]">
          <Button variant="outline" onClick={onClose} disabled={isLoading}>
            Cancel
          </Button>
          <Button
            type="button"
            onClick={handleSave}
            disabled={isLoading || tagName?.length === 0}
          >
            {isLoading ? 'Saving...' : 'Save'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default DialogaddTag;
